import Vue from 'utils/vueUtils';
import Contacts from '../collections/Contacts';
import Tags from '../collections/Tags';
import Conversations from '../collections/Conversations';
import Inboxes from '../collections/Inboxes';
import Members from '../collections/Members';
import IntegrationService from '../../services/integration';
import { baseApi } from 'core/api';
import { useConversationsStore } from 'store/modules';

const state = () => ({
    _sectionContacts: [
        {
            label: 'Salesmsg',
            key: 'salesmsg',
        },
        {
            label: 'Salesforce',
            key: 'salesforce',
        },
        {
            label: 'HubSpot',
            key: 'hubspot',
        },
        {
            label: 'ActiveCampaign',
            key: 'activecampaign',
        },
        {
            label: 'Keap',
            key: 'infusionsoft',
        },
        {
            label: 'Pipedrive',
            key: 'pipedrive',
        },
    ],
    _sectionContactsSelected: {
        label: 'Salesmsg',
        key: 'salesmsg',
    },

    _selectedTypeSearch: null,
    _selectedTypeItemsSearch: [],

    _searchContacts: [],
    _searchContactsLoading: false,
    _searchContactsPagination: {},
    _starterContacts: [],
    _starterContactsLoading: false,
    _starterContactsPagination: {},

    _searchContactsHubSpot: [],
    _searchContactsHubSpotLoading: false,
    _searchContactsHubSpotPagination: {},
    _starterContactsHubSpot: [],
    _starterContactsHubSpotLoading: false,
    _starterContactsHubSpotPagination: {},

    _searchContactsActiveCampaign: [],
    _searchContactsActiveCampaignLoading: false,
    _searchContactsActiveCampaignPagination: {},
    _starterContactsActiveCampaign: [],
    _starterContactsActiveCampaignLoading: false,
    _starterContactsActiveCampaignPagination: {},

    _searchContactsInfusionsoft: [],
    _searchContactsInfusionsoftLoading: false,
    _searchContactsInfusionsoftPagination: {},
    _starterContactsInfusionsoft: [],
    _starterContactsInfusionsoftLoading: false,
    _starterContactsInfusionsoftPagination: {},

    _searchContactsPipedrive: [],
    _searchContactsPipedriveLoading: false,
    _searchContactsPipedrivePagination: {},
    _starterContactsPipedrive: [],
    _starterContactsPipedriveLoading: false,
    _starterContactsPipedrivePagination: {},

    _searchContactsSalesforce: [],
    _searchContactsSalesforceLoading: false,
    _searchContactsSalesforcePagination: {},
    _starterContactsSalesforce: [],
    _starterContactsSalesforceLoading: false,
    _starterContactsSalesforcePagination: {},

    _searchConversations: [],
    _searchConversationsLoading: false,
    _searchConversationsPagination: {},

    _searchTags: [],
    _searchTagsLoading: false,
    _searchTagsPagination: {},

    _searchSegments: [],
    _searchSegmentsLoading: false,
    _searchSegmentsPagination: {},

    _searchInboxes: [],
    _searchInboxesLoading: false,
    _searchInboxesPagination: {},

    _searchMembers: [],
    _searchMembersLoading: false,
    _searchMembersPagination: {},

    _limit: 10,
    _querySearch: '',
    _queryStarting: '',
    _searchShowConversation: false,
    _searchDisabled: false,
    _searchCreateConversation: false,
});

const getters = {
    contactsSearch: (state) => state._searchContacts,
    contactsSearchPagination: (state) => state._searchContactsPagination,
    contactsSearchLoading: (state) => state._searchContactsLoading,
    contactsStarter: (state) => state._starterContacts,
    contactsStarterPagination: (state) => state._starterContactsPagination,
    contactsStarterLoading: (state) => state._starterContactsLoading,

    contactsHubSpotSearch: (state) => state._searchContactsHubSpot,
    contactsHubSpotSearchPagination: (state) => state._searchContactsHubSpotPagination,
    contactsHubSpotSearchLoading: (state) => state._searchContactsHubSpotLoading,
    contactsHubSpotStarter: (state) => state._starterContactsHubSpot,
    contactsHubSpotStarterPagination: (state) => state._starterContactsHubSpotPagination,
    contactsHubSpotStarterLoading: (state) => state._starterContactsHubSpotLoading,

    contactsActiveCampaignSearch: (state) => state._searchContactsActiveCampaign,
    contactsActiveCampaignSearchPagination: (state) =>
        state._searchContactsActiveCampaignPagination,
    contactsActiveCampaignSearchLoading: (state) => state._searchContactsActiveCampaignLoading,
    contactsActiveCampaignStarter: (state) => state._starterContactsActiveCampaign,
    contactsActiveCampaignStarterPagination: (state) =>
        state._starterContactsActiveCampaignPagination,
    contactsActiveCampaignStarterLoading: (state) => state._starterContactsActiveCampaignLoading,

    contactsInfusionsoftSearch: (state) => state._searchContactsInfusionsoft,
    contactsInfusionsoftSearchPagination: (state) => state._searchContactsInfusionsoftPagination,
    contactsInfusionsoftSearchLoading: (state) => state._searchContactsInfusionsoftLoading,
    contactsInfusionsoftStarter: (state) => state._starterContactsInfusionsoft,
    contactsInfusionsoftStarterPagination: (state) => state._starterContactsInfusionsoftPagination,
    contactsInfusionsoftStarterLoading: (state) => state._starterContactsInfusionsoftLoading,

    contactsPipedriveSearch: (state) => state._searchContactsPipedrive,
    contactsPipedriveSearchPagination: (state) => state._searchContactsPipedrivePagination,
    contactsPipedriveSearchLoading: (state) => state._searchContactsPipedriveLoading,
    contactsPipedriveStarter: (state) => state._starterContactsPipedrive,
    contactsPipedriveStarterPagination: (state) => state._starterContactsPipedrivePagination,
    contactsPipedriveStarterLoading: (state) => state._starterContactsPipedriveLoading,

    contactsSalesforceSearch: (state) => state._searchContactsSalesforce,
    contactsSalesforceSearchPagination: (state) => state._searchContactsSalesforcePagination,
    contactsSalesforceSearchLoading: (state) => state._searchContactsSalesforceLoading,
    contactsSalesforceStarter: (state) => state._starterContactsSalesforce,
    contactsSalesforceStarterPagination: (state) => state._starterContactsSalesforcePagination,
    contactsSalesforceStarterLoading: (state) => state._starterContactsSalesforceLoading,

    conversationsSearch: (state) => state._searchConversations,
    conversationsSearchPagination: (state) => state._searchConversationsPagination,
    conversationsSearchLoading: (state) => state._searchConversationsLoading,

    tagsSearch: (state) => state._searchTags,
    tagsSearchPagination: (state) => state._searchTagsPagination,
    tagsSearchLoading: (state) => state._searchTagsLoading,

    segmentsSearch: (state) => state._searchSegments,
    segmentsSearchPagination: (state) => state._searchSegmentsPagination,
    segmentsSearchLoading: (state) => state._searchSegmentsLoading,

    inboxesSearch: (state) => state._searchInboxes,
    inboxesSearchPagination: (state) => state._searchInboxesPagination,
    inboxesSearchLoading: (state) => state._searchInboxesLoading,

    membersSearch: (state) => state._searchMembers,
    membersSearchPagination: (state) => state._searchMembersPagination,
    membersSearchLoading: (state) => state._searchMembersLoading,

    contactsSearchAllLoading: (state) =>
        state._searchContactsLoading ||
        state._searchContactsHubSpotLoading ||
        state._searchContactsActiveCampaignLoading ||
        state._searchContactsInfusionsoftLoading ||
        state._searchContactsPipedriveLoading ||
        state._searchContactsSalesforceLoading ||
        state._searchConversationsLoading ||
        state._searchTagsLoading ||
        state._searchInboxesLoading ||
        state._searchMembersLoading,
    contactsStarterAllLoading: (state) =>
        state._starterContactsLoading ||
        state._starterContactsHubSpotLoading ||
        state._starterContactsActiveCampaignLoading ||
        state._starterContactsInfusionsoftLoading ||
        state._starterContactsPipedriveLoading ||
        state._starterContactsSalesforceLoading,

    searchLimit: (state) => state._limit,
    sectionContacts: (state) => state._sectionContacts,
    sectionContactsSelected: (state) => state._sectionContactsSelected,

    selectedTypeSearch: (state) => state._selectedTypeSearch,
    selectedTypeItemsSearch: (state) => state._selectedTypeItemsSearch,
    selectedTypeItemsSearchTags() {
        return this.selectedTypeItemsSearch
            .filter((item) => item.type === 'tag')
            .map((item) => item.value);
    },
    selectedTypeItemsSearchSegments() {
        return this.selectedTypeItemsSearch
            .filter((item) => item.type === 'segments')
            .map((item) => item.value);
    },
    selectedTypeItemsSearchContacts() {
        return this.selectedTypeItemsSearch
            .filter((item) => item.type === 'contact')
            .map((item) => item.value);
    },
    selectedTypeItemsSearchInboxs() {
        return this.selectedTypeItemsSearch
            .filter((item) => item.type === 'inbox')
            .map((item) => item.value);
    },
    selectedTypeItemsSearchMembers() {
        return this.selectedTypeItemsSearch
            .filter((item) => item.type === 'assigned_member')
            .map((item) => item.value);
    },
    selectedTypeItemsSearchDate() {
        return this.selectedTypeItemsSearch.find((item) => item.type === 'date');
    },
    searchTotalItemsCount() {
        return (
            this.contactsSearch.length +
            this.contactsHubSpotSearch.length +
            this.contactsActiveCampaignSearch.length +
            this.contactsInfusionsoftSearch.length +
            this.contactsPipedriveSearch.length +
            this.contactsSalesforceSearch.length +
            this.tagsSearch.length +
            this.inboxesSearch.length +
            this.segmentsSearch.length +
            this.membersSearch.length
        );
    },

    starterTotalItemsCount() {
        return (
            this.contactsStarter.length +
            this.contactsHubSpotStarter.length +
            this.contactsActiveCampaignStarter.length +
            this.contactsInfusionsoftStarter.length +
            this.contactsPipedriveStarter.length +
            this.contactsSalesforceStarter.length
        );
    },
    searchExistItemsCount() {
        return Boolean(
            this.contactsSearch.length ||
                this.contactsHubSpotSearch.length ||
                this.contactsActiveCampaignSearch.length ||
                this.contactsInfusionsoftSearch.length ||
                this.contactsPipedriveSearch.length ||
                this.contactsSalesforceSearch.length ||
                this.tagsSearch.length ||
                this.inboxesSearch.length ||
                this.membersSearch.length
        );
    },

    starterExistItemsCount() {
        return Boolean(
            this.contactsStarter.length ||
                this.contactsHubSpotStarter.length ||
                this.contactsActiveCampaignStarter.length ||
                this.contactsInfusionsoftStarter.length ||
                this.contactsPipedriveStarter.length ||
                this.contactsSalesforceStarter.length
        );
    },
    hasGlobalSearch() {
        return Boolean(!this.hasTypeSearch && !this.hasTypeItemsSearch);
    },
    hasTypeSearch: (state) => Boolean(state.selectedTypeSearch),
    hasTypeItemsSearch: (state) => Boolean(state.selectedTypeItemsSearch.length),

    showChooseTypeItems() {
        const searchGlobal = Boolean(
            this.hasGlobalSearch && !this.searchExistItemsCount && !this.querySearch
        );
        const searchTypeItems = Boolean(
            this.hasTypeItemsSearch && !this.searchExistItemsCount && !this.querySearch
        );

        if (this.hasTypeSearch) return false;

        return Boolean(searchGlobal || searchTypeItems);
    },

    showAllSearchItems() {
        const searchGlobal = Boolean(
            this.hasGlobalSearch && this.canSearchQuery && this.searchExistItemsCount
        );
        const searchTypeItems = Boolean(
            this.hasTypeItemsSearch && this.canSearchQuery && this.searchExistItemsCount
        );

        if (this.hasTypeSearch) return false;

        return Boolean(searchGlobal || searchTypeItems);
    },

    querySearch: (state) => state._querySearch,
    querySearchOne: (state) => state.querySearch.length >= 1,
    querySearchThree: (state) => state.querySearch.length >= 3,
    querySearchHelpOne: (state) =>
        !(state.querySearch && state.querySearch.length > 0 && state.querySearch.length < 1),
    querySearchHelpThree: (state) =>
        !(state.querySearch && state.querySearch.length > 0 && state.querySearch.length < 3),

    queryStarting: (state) => state._queryStarting,

    canSearchQuery() {
        const canSearchThree = this.querySearchThree;
        const canSearchOne = this.querySearchOne;
        const searchGlobal = this.hasGlobalSearch;
        const searchType = this.selectedTypeSearch;
        const searchTypeItems = this.hasTypeItemsSearch;

        if (searchGlobal) {
            // Global search
            return canSearchOne;
        }

        if (searchType) {
            // Type search
            return searchType === 'contacts' ? canSearchThree : true;
        }

        if (searchTypeItems) {
            // Type_Items search
            return canSearchOne;
        }

        return false;
    },
    canSearchQueryHelp() {
        const canSearchHelpThree = this.querySearchHelpThree;
        const canSearchHelpOne = this.querySearchHelpOne;
        const searchGlobal = this.hasGlobalSearch;
        const searchType = this.selectedTypeSearch;
        const searchTypeItems = this.hasTypeItemsSearch;

        if (searchGlobal) {
            // Global search
            return canSearchHelpOne;
        }

        if (searchType) {
            // Type search
            return searchType === 'contacts' ? canSearchHelpThree : true;
        }

        if (searchTypeItems) {
            // Type_Items search
            return canSearchHelpOne;
        }

        return false;
    },
    canSearchQuerySimple: (state) => state.querySearch && state.querySearch.length >= 3,
    canSearchQuerySimpleHelp: (state) =>
        !(state.querySearch && state.querySearch.length > 0 && state.querySearch.length < 3),
    canStartingQuery: (state) => state.queryStarting && state.queryStarting.length >= 3,
    canStartingQueryHelp: (state) =>
        !(state.queryStarting && state.queryStarting.length > 0 && state.queryStarting.length < 3),

    searchShowConversation: (state) => state._searchShowConversation,
    searchDisabled: (state) => state._searchDisabled,
    searchCreateConversation: (state) => state._searchCreateConversation,
};

const actions = {
    setContactsSearchLoading({ status, type = 'salesmsg' }) {
        this._setContactsSearchLoading({ status, type });
    },

    setContactsSearchQueryUpdate(query) {
        this._setSearchContactsQueryUpdate(query);
    },

    // Update page
    setContactsSearchUpdatePage(data) {
        const options = typeof data === 'object' ? data : { page: data };

        this.searchContacts({
            cancelToken: null,
            ...options,
        });
    },

    contactsBroadcastSearchUpdatePage(data) {
        const options = typeof data === 'object' ? data : { page: data };

        this.searchContacts({
            cancelToken: null,
            excludeOptOut: true,
            ...options,
        });
    },

    contactsActiveCampaignSearchUpdatePage(data) {
        const options = typeof data === 'object' ? data : { page: data };

        this.searchContactsActiveCampaign({
            cancelToken: null,
            ...options,
        });
    },

    contactsHubSpotSearchUpdatePage(data) {
        const options = typeof data === 'object' ? data : { page: data };

        this.searchContactsHubSpot({
            cancelToken: null,
            ...options,
        });
    },

    contactsInfusionsoftSearchUpdatePage(data) {
        const options = typeof data === 'object' ? data : { page: data };

        this.searchContactsInfusionsoft({
            cancelToken: null,
            ...options,
        });
    },

    contactsPipedriveSearchUpdatePage(data) {
        const options = typeof data === 'object' ? data : { page: data };

        this.searchContactsPipedrive({
            cancelToken: null,
            ...options,
        });
    },

    contactsSalesforceSearchUpdatePage(data) {
        const options = typeof data === 'object' ? data : { page: data };

        this.searchContactsSalesforce({
            cancelToken: null,
            ...options,
        });
    },

    conversationsSearchUpdatePage(page) {
        this.searchConversations({
            cancelToken: null,
            page: page,
        });
    },

    tagsSearchUpdatePage(page) {
        this.searchTags({
            cancelToken: null,
            page: page,
        });
    },

    segmentsSearchUpdatePage(page) {
        this.searchSegments({
            cancelToken: null,
            page: page,
        });
    },

    inboxesSearchUpdatePage(page) {
        this.searchInboxes({
            cancelToken: null,
            page: page,
        });
    },

    assignedMembersSearchUpdatePage(page) {
        this.searchAssignedMembers({
            cancelToken: null,
            page: page,
        });
    },

    // Reset
    searchResetContact(type) {
        this._setSearchContactsReset(type);
    },

    searchResetHubSpotContact(type) {
        this._setSearchContactsHubspotReset(type);
    },

    searchResetActiveCompaignContact(type) {
        this._setSearchContactsActiveCampaignReset(type);
    },

    searchResetInfusionsoftContact(type) {
        this._setSearchContactsInfusionsoftReset(type);
    },

    searchResetPipedriveContact(type) {
        this._setSearchContactsPipedriveReset(type);
    },

    searchResetSalesforceContact(type) {
        this._setSearchContactsSalesforceReset(type);
    },

    searchResetConversations() {
        this._setSearchConversationsReset();
    },

    searchResetTags() {
        this._setSearchTagsReset();
    },

    searchResetInboxes() {
        this._setSearchInboxesReset();
    },

    searchResetAssignedMembers() {
        this._setSearchAssignedMembersReset();
    },

    // Search
    async searchContacts({
        cancelToken,
        page = 1,
        update = true,
        isSearchTop = false,
        query = '',
        searchType = 'search',
        excludeOptOut = false,
    }) {
        const baseQuery = isSearchTop ? this.querySearch : this.queryStarting;
        const queryNumber = baseQuery || query;
        const options = {
            params: {
                term: queryNumber,
                per_page: this._limit,
                page: page,
                exclude: this.selectedTypeItemsSearchContacts,
                tags: this.selectedTypeItemsSearchTags,
                skip_opted_out: excludeOptOut ? 1 : 0,
            },
        };

        if (cancelToken) {
            options.cancelToken = cancelToken.token;
        }

        if (update) {
            this._setContactsSearchLoading({ status: true, type: 'salesmsg', searchType });
        }

        try {
            const contacts = await baseApi.get('core/contacts/search', options);

            if (update) {
                this._setSearchContactsLoaded({
                    data: contacts.data,
                    page: page,
                    searchType,
                });
                this._setContactsSearchLoading({
                    status: false,
                    type: 'salesmsg',
                    searchType,
                });
            }

            const contactsResponse = new Contacts(contacts.data.results || []);

            return contactsResponse.modelsSorted;
        } catch (e) {
            if (update) {
                this._setContactsSearchLoading({
                    status: false,
                    type: 'salesmsg',
                    searchType,
                });
            }

            throw e;
        }
    },

    getIntegrationsContactsSearch(params) {
        if (
            params.integration_key &&
            IntegrationService.useMicroIntegration(params.integration_key)
        ) {
            return baseApi
                .get(`integration/contacts/${params.integration_key}/search`, {
                    params: { ...params, fields: params.field ? [params.field] : [] },
                })
                .then((response) => {
                    const integrationContacts = response.data.data
                        ? response.data.data.map((item) => ({
                              ...item,
                              integration_type: params.integration_key,
                          }))
                        : [];

                    const contacts = new Contacts(integrationContacts || []);
                    return contacts.modelsSorted;
                });
        }

        return baseApi.get('core/integrations/contacts/search', { params }).then((response) => {
            const contacts = new Contacts(response.data.data || []);

            return contacts.modelsSorted;
        });
    },

    async searchContactsHubSpot({
        cancelToken,
        query,
        page = 1,
        limit,
        updateCollection = true,
        isSearchTop = false,
        searchType = 'search',
    }) {
        query = query || (isSearchTop ? this.querySearch : this.queryStarting);
        const options = {
            params: {
                term: query,
                per_page: limit || this._limit,
                page: page,
                exclude: this.selectedTypeItemsSearchContacts,
                tags: this.selectedTypeItemsSearchTags,
            },
        };

        if (cancelToken) {
            options.cancelToken = cancelToken.token;
        }

        if (updateCollection) {
            this._setContactsSearchLoading({ status: true, type: 'hubspot', searchType });
        }

        try {
            const contacts = await baseApi.get('core/integrations/contacts/hubspot', options);

            if (updateCollection) {
                this._setSearchContactsHubspotLoaded({
                    data: contacts.data,
                    page: page,
                    searchType,
                });
                this._setContactsSearchLoading({
                    status: false,
                    type: 'hubspot',
                    searchType,
                });
            }

            const contactsResponse = new Contacts(contacts.data.results || []);

            return contactsResponse.modelsSorted;
        } catch (e) {
            this._setContactsSearchLoading({ status: false, type: 'hubspot', searchType });

            throw e;
        }
    },

    async searchContactsActiveCampaign({
        cancelToken,
        query,
        page = 1,
        limit,
        updateCollection = true,
        isSearchTop = false,
        searchType = 'search',
    }) {
        query = query || (isSearchTop ? this.querySearch : this.queryStarting);
        const options = {
            params: {
                term: query,
                per_page: limit || this._limit,
                page: page,
                exclude: this.selectedTypeItemsSearchContacts,
                tags: this.selectedTypeItemsSearchTags,
            },
        };

        if (cancelToken) {
            options.cancelToken = cancelToken.token;
        }

        if (updateCollection) {
            this._setContactsSearchLoading({
                status: true,
                type: 'activecampaign',
                searchType,
            });
        }

        try {
            const contacts = await baseApi.get(
                'core/integrations/contacts/activecampaign',
                options
            );

            if (updateCollection) {
                this._setSearchContactsActiveCampaignLoaded({
                    data: contacts.data,
                    page: page,
                    searchType,
                });
                this._setContactsSearchLoading({
                    status: false,
                    type: 'activecampaign',
                    searchType,
                });
            }

            const contactsResponse = new Contacts(contacts.data.results || []);

            return contactsResponse.modelsSorted;
        } catch (e) {
            this._setContactsSearchLoading({
                status: false,
                type: 'activecampaign',
                searchType,
            });

            throw e;
        }
    },

    async searchContactsInfusionsoft({
        cancelToken,
        query,
        page = 1,
        limit,
        updateCollection = true,
        isSearchTop = false,
        searchType = 'search',
    }) {
        query = query || (isSearchTop ? this.querySearch : this.queryStarting);
        const options = {
            params: {
                term: query,
                per_page: limit || this._limit,
                page: page,
                exclude: this.selectedTypeItemsSearchContacts,
                tags: this.selectedTypeItemsSearchTags,
            },
        };

        if (cancelToken) {
            options.cancelToken = cancelToken.token;
        }

        if (updateCollection) {
            this._setContactsSearchLoading({
                status: true,
                type: 'infusionsoft',
                searchType,
            });
        }

        try {
            const contacts = await baseApi.get('core/integrations/contacts/infusionsoft', options);

            if (updateCollection) {
                this._setSearchContactsInfusionsoftLoaded({
                    data: contacts.data,
                    page: page,
                    searchType,
                });
                this._setContactsSearchLoading({
                    status: false,
                    type: 'infusionsoft',
                    searchType,
                });
            }

            const contactsResponse = new Contacts(contacts.data.results || []);

            return contactsResponse.modelsSorted;
        } catch (e) {
            this._setContactsSearchLoading({
                status: false,
                type: 'infusionsoft',
                searchType,
            });

            throw e;
        }
    },

    async searchContactsPipedrive({
        cancelToken,
        query,
        page = 1,
        limit,
        updateCollection = true,
        isSearchTop = false,
        searchType = 'search',
    }) {
        query = query || (isSearchTop ? this.querySearch : this.queryStarting);
        const options = {
            params: {
                term: query,
                per_page: limit || this._limit,
                page: page,
                exclude: this.selectedTypeItemsSearchContacts,
                tags: this.selectedTypeItemsSearchTags,
            },
        };

        if (cancelToken) {
            options.cancelToken = cancelToken.token;
        }

        if (updateCollection) {
            this._setContactsSearchLoading({ status: true, type: 'pipedrive', searchType });
        }

        try {
            const contacts = await baseApi.get('core/integrations/contacts/pipedrive', options);

            if (updateCollection) {
                this._setSearchContactsPipedriveLoaded({
                    data: contacts.data,
                    page: page,
                    searchType,
                });
                this._setContactsSearchLoading({
                    status: false,
                    type: 'pipedrive',
                    searchType,
                });
            }

            const contactsResponse = new Contacts(contacts.data.results || []);

            return contactsResponse.modelsSorted;
        } catch (e) {
            this._setContactsSearchLoading({ status: false, type: 'pipedrive', searchType });

            throw e;
        }
    },

    async searchContactsSalesforce({
        cancelToken,
        query,
        page = 1,
        limit,
        updateCollection = true,
        isSearchTop = false,
        searchType = 'search',
    }) {
        query = query || (isSearchTop ? this.querySearch : this.queryStarting);
        const options = {
            params: {
                term: query,
                per_page: limit || this._limit,
                page: page,
                exclude: this.selectedTypeItemsSearchContacts,
                tags: this.selectedTypeItemsSearchTags,
            },
        };

        if (cancelToken) {
            options.cancelToken = cancelToken.token;
        }

        if (updateCollection) {
            this._setContactsSearchLoading({ status: true, type: 'salesforce', searchType });
        }

        try {
            const contacts = await baseApi.get('core/integrations/contacts/salesforce', options);

            if (updateCollection) {
                this._setSearchContactsSalesforceLoaded({
                    data: contacts.data,
                    page: page,
                    searchType,
                });
                this._setContactsSearchLoading({
                    status: false,
                    type: 'salesforce',
                    searchType,
                });
            }

            const contactsResponse = new Contacts(contacts.data.results || []);

            return contactsResponse.modelsSorted;
        } catch (e) {
            this._setContactsSearchLoading({
                status: false,
                type: 'salesforce',
                searchType,
            });

            throw e;
        }
    },

    async searchSegments({ cancelToken, page = 1, update = true }) {
        const query = this.querySearch;

        const options = {
            params: {
                term: !query ? '*' : query,
                per_page: this._limit,
                page: page,
                exclude: this.selectedTypeItemsSearchSegments,
            },
        };

        if (cancelToken) {
            options.cancelToken = cancelToken.token;
        }

        if (update) {
            this._setContactsSearchLoading({ status: true, type: 'segments' });
        }

        try {
            const segments = await baseApi.get('core/organization/segments/search', options);

            if (update) {
                this._setSearchSegmentsLoaded({ data: segments.data, page: page });
                this._setContactsSearchLoading({ status: false, type: 'segments' });
            }

            return segments;
        } catch (e) {
            this._setContactsSearchLoading({ status: false, type: 'segments' });

            throw e;
        }
    },

    async getNotesSearch({ options }) {
        try {
            const notes = await baseApi.get('core/notes/search', options);

            return notes.data;
        } catch (e) {
            throw e;
        }
    },

    async searchTags({ cancelToken, page = 1, update = true, isSearchTop = false, options }) {
        const query = this.querySearch;

        options = options || {
            params: {
                term: !query ? '*' : query,
                per_page: this._limit,
                page: page,
                exclude: this.selectedTypeItemsSearchTags,
            },
        };

        if (cancelToken) {
            options.cancelToken = cancelToken.token;
        }

        if (update) {
            this._setContactsSearchLoading({ status: true, type: 'tags' });
        }

        try {
            const tags = await baseApi.get('core/tags/search', options);

            if (update) {
                this._setSearchTagsLoaded({ data: tags.data, page: page });
                this._setContactsSearchLoading({ status: false, type: 'tags' });
            }

            const contactsResponse = new Tags(tags.data.results || []);

            return contactsResponse.models;
        } catch (e) {
            this._setContactsSearchLoading({ status: false, type: 'tags' });

            throw e;
        }
    },

    async searchInboxes({ cancelToken, page = 1, update = true, isSearchTop = false }) {
        const query = this.querySearch;
        const options = {
            params: {
                term: !query ? '*' : query,
                per_page: this._limit,
                page: page,
                exclude: this.selectedTypeItemsSearchInboxs,
            },
        };

        if (cancelToken) {
            options.cancelToken = cancelToken.token;
        }

        if (update) {
            this._setContactsSearchLoading({ status: true, type: 'inboxes' });
        }

        try {
            const items = await baseApi.get('core/teams/search', options);

            items.data.results = items.data.results.filter((item) => item);

            if (update) {
                this._setSearchInboxesLoaded({ data: items.data, page: page });
                this._setContactsSearchLoading({ status: false, type: 'inboxes' });
            }

            return new Inboxes(items.data.results || []).models;
        } catch (e) {
            this._setContactsSearchLoading({ status: false, type: 'inboxes' });

            throw e;
        }
    },

    async searchAssignedMembers({ cancelToken, page = 1, update = true, isSearchTop = false }) {
        const query = this.querySearch;
        const options = {
            params: {
                term: !query ? '*' : query,
                per_page: this._limit,
                page: page,
                exclude: this.selectedTypeItemsSearchMembers,
            },
        };

        if (cancelToken) {
            options.cancelToken = cancelToken.token;
        }

        if (update) {
            this._setContactsSearchLoading({ status: true, type: 'members' });
        }

        try {
            const items = await baseApi.get('core/users/search', options);

            if (update) {
                this._setSearchAssignedMembersLoaded({ data: items.data, page: page });
                this._setContactsSearchLoading({ status: false, type: 'members' });
            }

            return new Members(items.data.results || []).models;
        } catch (e) {
            this._setContactsSearchLoading({ status: false, type: 'members' });

            throw e;
        }
    },

    // Main Search
    async searchConversations({
        cancelToken,
        page = 1,
        update = true,
        isSearchTop = false,
        enableLoading = true,
        isSearch = true,
        setPagination = false,
        intersectionContacts = false,
    } = {}) {
        const query = this.querySearch;
        const options = {
            params: {
                term: query,
                per_page: this._limit,
                page: page,
                contacts: [],
                tags: [],
                from: '',
                to: '',
            },
        };

        options.params.tags = this.selectedTypeItemsSearchTags;
        options.params.contacts = this.selectedTypeItemsSearchContacts;
        options.params.teams = this.selectedTypeItemsSearchInboxs;
        options.params.members = this.selectedTypeItemsSearchMembers;

        if (intersectionContacts) {
            options.params.intersectionContacts = 1;
        }

        if (this.selectedTypeItemsSearchDate) {
            options.params.from = this.selectedTypeItemsSearchDate.value.from;
            options.params.to = this.selectedTypeItemsSearchDate.value.to;
        }

        if (cancelToken) {
            options.cancelToken = cancelToken.token;
        }

        if (update) {
            if (enableLoading) {
                this._setContactsSearchLoading({ status: true, type: 'conversations' });
            }
            useConversationsStore()._setConversationsLoaded({
                conversations: [],
                isMore: true,
                isSearch: isSearch,
            });
        }

        try {
            let response = await baseApi.get('core/conversations/search', options);

            response.data.results = Array.isArray(response.data.results)
                ? response.data.results
                : [];
            response.data.results = response.data.results.map((item) => {
                return item._source || item;
            });

            const items = new Conversations(response.data.results || []);
            const isMore = response.data.total / (this._limit * page) >= 1;

            if (update) {
                this._setSearchConversationsLoaded({
                    data: response.data,
                    page: page,
                });
                useConversationsStore()._setConversationsLoaded({
                    conversations: items.models,
                    isMore: isMore,
                    page: page,
                    isSearch: isSearch,
                    setPagination: setPagination,
                });
                this._setContactsSearchLoading({ status: false, type: 'conversations' });
            }

            return items.models;
        } catch (e) {
            this._setContactsSearchLoading({ status: false, type: 'conversations' });

            throw e;
        }
    },

    searchUpdateState(data) {
        this._setSearchUpdateState(data);
    },

    _setSearchContactsQueryUpdate(query) {
        this._querySearch = query;
    },

    _setSearchContactsReset(type = 'search') {
        this[`_${type}Contacts`] = [];
        this[`_${type}ContactsPagination`] = {};
    },

    _setSearchContactsHubspotReset(type = 'search') {
        this[`_${type}ContactsHubSpot`] = [];
        this[`_${type}ContactsHubSpotPagination`] = {};
    },

    _setSearchContactsActiveCampaignReset(type = 'search') {
        this[`_${type}ContactsActiveCampaign`] = [];
        this[`_${type}ContactsActiveCampaignPagination`] = {};
    },

    _setSearchContactsInfusionsoftReset(type = 'search') {
        this[`_${type}ContactsInfusionsoft`] = [];
        this[`_${type}ContactsInfusionsoftPagination`] = {};
    },

    _setSearchContactsPipedriveReset(type = 'search') {
        this[`_${type}ContactsPipedrive`] = [];
        this[`_${type}ContactsPipedrivePagination`] = {};
    },

    _setSearchContactsSalesforceReset(type = 'search') {
        this[`_${type}ContactsSalesforce`] = [];
        this[`_${type}ContactsSalesforcePagination`] = {};
    },

    _setSearchConversationsReset() {
        this._searchConversations = [];
        this._searchConversationsPagination = {};
    },

    _setSearchTagsReset() {
        this._searchTags = [];
        this._searchTagsPagination = {};
    },

    _setSearchInboxesReset() {
        this._searchInboxes = [];
        this._searchInboxesPagination = {};
    },

    _setSearchAssignedMembersReset() {
        this._searchMembers = [];
        this._searchMembersPagination = {};
    },

    _setSearchContactsLoaded({ data, page, searchType }) {
        const results = data.results || [];
        const total = data.total || 0;
        const contacts = new Contacts(results);
        const limit = this._limit;
        const currentPage = page;
        const from = currentPage === 1 ? 1 : (currentPage - 1) * limit + 1;
        const to =
            currentPage === 1
                ? limit
                : (currentPage - 1) * limit + (Math.abs((currentPage - 1) * limit - total) % 10);

        this[`_${searchType}Contacts`] = contacts.modelsSorted;
        this[`_${searchType}ContactsPagination`] = {
            current_page: currentPage,
            last_page: Math.ceil(total / limit),
            per_page: limit,
            from: from,
            to: to,
            total: total,
        };
    },

    _setSearchContactsHubspotLoaded({ data, page, searchType }) {
        const results = data.results || [];
        const total = data.total || 0;
        const contacts = new Contacts(results);
        const limit = this._limit;
        const currentPage = page;
        const from = currentPage === 1 ? 1 : (currentPage - 1) * limit + 1;
        const to =
            currentPage === 1
                ? limit
                : (currentPage - 1) * limit + (Math.abs((currentPage - 1) * limit - total) % 10);

        this[`_${searchType}ContactsHubSpot`] = contacts.modelsSorted;
        this[`_${searchType}ContactsHubSpotPagination`] = {
            current_page: currentPage,
            last_page: Math.ceil(total / limit),
            per_page: limit,
            from: from,
            to: to,
            total: total,
        };
    },

    _setSearchContactsActiveCampaignLoaded({ data, page, searchType }) {
        const results = data.results || [];
        const total = data.total || 0;
        const contacts = new Contacts(results);
        const limit = this._limit;
        const currentPage = page;
        const from = currentPage === 1 ? 1 : (currentPage - 1) * limit + 1;
        const to =
            currentPage === 1
                ? limit
                : (currentPage - 1) * limit + (Math.abs((currentPage - 1) * limit - total) % 10);

        this[`_${searchType}ContactsActiveCampaign`] = contacts.modelsSorted;
        this[`_${searchType}ContactsActiveCampaignPagination`] = {
            current_page: currentPage,
            last_page: Math.ceil(total / limit),
            per_page: limit,
            from: from,
            to: to,
            total: total,
        };
    },

    _setSearchContactsInfusionsoftLoaded({ data, page, searchType }) {
        const results = data.results || [];
        const total = data.total || 0;
        const contacts = new Contacts(results);
        const limit = this._limit;
        const currentPage = page;
        const from = currentPage === 1 ? 1 : (currentPage - 1) * limit + 1;
        const to =
            currentPage === 1
                ? limit
                : (currentPage - 1) * limit + (Math.abs((currentPage - 1) * limit - total) % 10);

        this[`_${searchType}ContactsInfusionsoft`] = contacts.modelsSorted;
        this[`_${searchType}ContactsInfusionsoftPagination`] = {
            current_page: currentPage,
            last_page: Math.ceil(total / limit),
            per_page: limit,
            from: from,
            to: to,
            total: total,
        };
    },

    _setSearchContactsPipedriveLoaded({ data, page, searchType }) {
        const results = data.results || [];
        const total = data.total || 0;
        const contacts = new Contacts(results);
        const limit = this._limit;
        const currentPage = page;
        const from = currentPage === 1 ? 1 : (currentPage - 1) * limit + 1;
        const to =
            currentPage === 1
                ? limit
                : (currentPage - 1) * limit + (Math.abs((currentPage - 1) * limit - total) % 10);

        this[`_${searchType}ContactsPipedrive`] = contacts.modelsSorted;
        this[`_${searchType}ContactsPipedrivePagination`] = {
            current_page: currentPage,
            last_page: Math.ceil(total / limit),
            per_page: limit,
            from: from,
            to: to,
            total: total,
        };
    },

    _setSearchContactsSalesforceLoaded({ data, page, searchType }) {
        const results = data.results || [];
        const total = data.total || 0;
        const contacts = new Contacts(results);
        const limit = this._limit;
        const currentPage = page;
        const from = currentPage === 1 ? 1 : (currentPage - 1) * limit + 1;
        const to =
            currentPage === 1
                ? limit
                : (currentPage - 1) * limit + (Math.abs((currentPage - 1) * limit - total) % 10);

        this[`_${searchType}ContactsSalesforce`] = contacts.modelsSorted;
        this[`_${searchType}ContactsSalesforcePagination`] = {
            current_page: currentPage,
            last_page: Math.ceil(total / limit),
            per_page: limit,
            from: from,
            to: to,
            total: total,
        };
    },

    _setSearchConversationsLoaded({ data, page }) {
        const results = data.results || [];
        const total = data.total || 0;
        const items = new Conversations(results);
        const limit = this._limit;
        const currentPage = page;
        const from = currentPage === 1 ? 1 : (currentPage - 1) * limit + 1;
        const to =
            currentPage === 1
                ? limit
                : (currentPage - 1) * limit + (Math.abs((currentPage - 1) * limit - total) % 10);

        this._searchConversations = items.models;
        this._searchConversationsPagination = {
            current_page: currentPage,
            last_page: Math.ceil(total / limit),
            per_page: limit,
            from: from,
            to: to,
            total: total,
        };
    },

    _setSearchTagsLoaded({ data, page }) {
        const results = data.results || [];
        const total = data.total || 0;
        const tags = new Tags(results);
        const limit = this._limit;
        const currentPage = page;
        const from = currentPage === 1 ? 1 : (currentPage - 1) * limit + 1;
        const to =
            currentPage === 1
                ? limit
                : (currentPage - 1) * limit + (Math.abs((currentPage - 1) * limit - total) % 10);

        this._searchTags = tags.models;
        this._searchTagsPagination = {
            current_page: currentPage,
            last_page: Math.ceil(total / limit),
            per_page: limit,
            from: from,
            to: to,
            total: total,
        };
    },

    _setSearchSegmentsLoaded({ data, page }) {
        const results = data.results || [];
        const total = data.total || 0;
        const limit = this._limit;
        const currentPage = page;
        const from = currentPage === 1 ? 1 : (currentPage - 1) * limit + 1;
        const to =
            currentPage === 1
                ? limit
                : (currentPage - 1) * limit + (Math.abs((currentPage - 1) * limit - total) % 10);

        this._searchSegments = results;
        this._searchSegmentsPagination = {
            current_page: currentPage,
            last_page: Math.ceil(total / limit),
            per_page: limit,
            from: from,
            to: to,
            total: total,
        };
    },

    _setSearchInboxesLoaded({ data, page }) {
        const results = data.results || [];
        const total = data.total || 0;
        const items = new Inboxes(results);
        const limit = this._limit;
        const currentPage = page;
        const from = currentPage === 1 ? 1 : (currentPage - 1) * limit + 1;
        const to =
            currentPage === 1
                ? limit
                : (currentPage - 1) * limit + (Math.abs((currentPage - 1) * limit - total) % 10);

        this._searchInboxes = items.models;
        this._searchInboxesPagination = {
            current_page: currentPage,
            last_page: Math.ceil(total / limit),
            per_page: limit,
            from: from,
            to: to,
            total: total,
        };
    },

    _setSearchAssignedMembersLoaded({ data, page }) {
        const results = data.results || [];
        const total = data.total || 0;
        const items = new Members(results);
        const limit = this._limit;
        const currentPage = page;
        const from = currentPage === 1 ? 1 : (currentPage - 1) * limit + 1;
        const to =
            currentPage === 1
                ? limit
                : (currentPage - 1) * limit + (Math.abs((currentPage - 1) * limit - total) % 10);

        this._searchMembers = items.models;
        this._searchMembersPagination = {
            current_page: currentPage,
            last_page: Math.ceil(total / limit),
            per_page: limit,
            from: from,
            to: to,
            total: total,
        };
    },

    _setSearchUpdateState(data) {
        for (let key in data) {
            const mappedKey = key.startsWith('_') ? key : `_${key}`;
            Vue.set(this, mappedKey, data[key]);
        }
    },

    _setContactsSearchLoading({ status, type, searchType }) {
        if (type === 'salesmsg') {
            this[`_${searchType}ContactsLoading`] = status;
        }

        if (type === 'segments') {
            this[`_${searchType}SegmentsLoading`] = status;
        }

        if (type === 'hubspot') {
            this[`_${searchType}ContactsHubSpotLoading`] = status;
        }

        if (type === 'activecampaign') {
            this[`_${searchType}ContactsActiveCampaignLoading`] = status;
        }

        if (type === 'infusionsoft') {
            this[`_${searchType}ContactsInfusionsoftLoading`] = status;
        }

        if (type === 'pipedrive') {
            this[`_${searchType}ContactsPipedriveLoading`] = status;
        }

        if (type === 'salesforce') {
            this[`_${searchType}ContactsSalesforceLoading`] = status;
        }

        if (type === 'conversations') {
            this._searchShowConversation = true;
            this._searchConversationsLoading = status;
        }

        if (type === 'tags') {
            this._searchTagsLoading = status;
        }

        if (type === 'inboxes') {
            this._searchInboxesLoading = status;
        }

        if (type === 'members') {
            this._searchMembersLoading = status;
        }
    },
};

export default {
    state,
    getters,
    actions,
};
